import {
  CHARACTER_WHITESPACE,
  EMPTY_STRING,
} from '../../../../constants/common'
import { FILE_NAME_WHITESPACE_REGEXP } from '../../../../constants/file'
import { GRETA_DRAFT_CHAT_TITLE_MAX_LENGTH } from '../../GretaAIChat.constants'
import { getIsGretaAIChatUserRole } from '../../GretaAIChatMessage'

export function extractGretaAIChatConversationId(response) {
  return response?.data?.id
}

export function getGretaAIChatDraftTitle(messages) {
  const question =
    messages.find(message => getIsGretaAIChatUserRole(message.role))?.text ??
    EMPTY_STRING
  const oneLine = question
    .replace(FILE_NAME_WHITESPACE_REGEXP, CHARACTER_WHITESPACE)
    .trim()

  return oneLine.length > GRETA_DRAFT_CHAT_TITLE_MAX_LENGTH
    ? `${oneLine.slice(0, GRETA_DRAFT_CHAT_TITLE_MAX_LENGTH - 1).trimEnd()}…`
    : oneLine
}
